module.exports = __webpack_public_path__ + "img/mascot-register.60d8fa00.png";